import { VenueType, VenueValues } from '../types';

export class VenueFactory {
    public static empty(): VenueValues {
        return {
            id: '',
            name: '',
            address: {
                address1: '',
                address2: '',
                city: '',
                country: '',
                latitude: '',
                longitude: '',
                postalCode: '',
                region: '',
                localizedAddress: '',
            },
            latitude: '37.780138',
            longitude: '-122.394055',
            type: VenueType.Venue,
        };
    }
}
